import { BalConfigState, BalSwissLanguage } from '@baloise/design-system-components';
import { CipCodeSprache } from '@/app/generated/dto/dto-typings';

export const setLanguage = (config: BalConfigState, isLanguageSetFlag: boolean, routeLang: string): string => {
    let lang: string = routeLang;
    if (!isLanguageSetFlag) {
        if (routeLang !== config.language as BalSwissLanguage) {
            lang = routeLang;
        }
    } else {
        lang = config.language as BalSwissLanguage;
    }
    return lang;
};

export const languageOfCorrespondenceToString = (language: CipCodeSprache | undefined): string => {
    switch (language) {
        case CipCodeSprache.DEUTSCH:
            return 'de';
        case CipCodeSprache.FRANZOESISCH:
            return 'fr';
        case CipCodeSprache.ITALIENISCH:
            return 'it';
        case CipCodeSprache.ENGLISCH:
            return 'en';
        case CipCodeSprache.NULL_CODE:
        default:
            return 'de';
    }
};

export const stringToLanguageOfCorrespondence = (language: string): CipCodeSprache => {
    switch (language) {
        case 'de':
            return CipCodeSprache.DEUTSCH;
        case 'fr':
            return CipCodeSprache.FRANZOESISCH;
        case 'it':
            return CipCodeSprache.ITALIENISCH;
        case 'en':
            return CipCodeSprache.ENGLISCH;
        default:
            return CipCodeSprache.DEUTSCH;
    }
};
